import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"
import { classes } from  '@shared/api/services';

export const useAddAppointmentByTeacher = (params) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => classes.createClassByTeacher(...data),
    onSuccess: () => {
      // Все диапазоны расписания, а не только текущий; списки ученика тоже меняются
      queryClient.invalidateQueries({ queryKey: ['appointments'] })
      queryClient.invalidateQueries({ queryKey: ['upcoming-appointments'] })
      queryClient.invalidateQueries({ queryKey: ['history'] })
			toast.success('Занятие добавлено')
    },
  })

	return mutation
}